// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1SS1g","content":"RecentSearches_content__3XZb1"};